import { makeStyles } from '@material-ui/core';

import { inputErrorBorder } from '@/styles/inputStyles.ts';

export const useStyles = makeStyles((theme) => ({
    //
    textFields: {
        height: '3.75em',
        // marginTop: 10,
    },
    inputLabel: {
        '&.focused': {
            color: theme.palette.common.darkGrey,
        },
        '&.shrink': {
            fontSize: '1rem',
        },
    },
    filledInputRoot: {
        overflow: 'hidden',
        backgroundColor: 'white',
        border: '1px solid #ABABAB',
        paddingRight: 10,
        borderRadius: 5,
        fontSize: '1rem',
        height: '100%',
        '&:hover': {
            backgroundColor: '#F9F8F4',
        },
    },
    fieldFocused: {
        backgroundColor: 'white',
        border: `2px solid ${theme.palette.common.yellow} !important`,
    },
    errorText: {
        fontSize: '0.875rem',
        textTransform: 'none',
        lineHeight: '1.5rem',
        color: theme.palette.common.red,
    },
    textFieldsError: {
        height: '3.75em',
        ...inputErrorBorder,
    },
}));
